export default __webpack_public_path__ + "static/media/discord.20853180.svg";